
import { useUI } from "providers/UIProvider";

import SettingsLayout from "components/shared/layouts/SettingsLayout";

import BookingFeeTabs from "./BookingFeeTabs";
import BookingFeeForm from "./BookingFeeForm";

const BookingFeeTemplate = () => {
  const { T } = useUI()

  return (
    <SettingsLayout title={T("booking_fee.title")}>
      <>
        <BookingFeeTabs />
        <BookingFeeForm />
      </>
    </SettingsLayout>
  )
}

export default BookingFeeTemplate